import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { gameLayers } from "game-layers";
import { FowlSoundEvents } from "setup/fowl-sound-events";
import { SignalBinding } from "signals";
import { SlingoReelSpinResult } from "slingo/model/results/slingo-reel-spin-result";
import { SlingoSpinState } from "slingo/states/slingo-spin-state";
import { MatrixComponent } from "slotworks/components/matrix/matrix-component";

export class FowlSpinState extends SlingoSpinState {
    protected anticipationBindings: SignalBinding[] = [];

    public onExit(): void {
        this.anticipationBindings.forEach(binding => binding.detach());
        this.anticipationBindings.length = 0;

        super.onExit();
    }

    protected stopReels(result: SlingoReelSpinResult): Contract<void> {
        const matrix = Components.get(MatrixComponent);
        const anticipationHighlight = gameLayers.MatrixBackground.getShape("anticipation_highlight");

        this.anticipationBindings.push(
            matrix.onAnticipationReel.add(reelIndex => {
                const pos = gameLayers.MatrixContent.getPosition(`symbol_${reelIndex}_0`);

                anticipationHighlight.landscape.setPosition(pos.landscape);
                anticipationHighlight.landscape.setSize(pos.landscape);
                anticipationHighlight.portrait.setPosition(pos.portrait);
                anticipationHighlight.portrait.setSize(pos.portrait);
                anticipationHighlight.visible = true;
            }),
            matrix.onAnticipationEnd.add(() => {
                anticipationHighlight.visible = false;
            })
        );

        return super.stopReels(result);
    }

    protected onReelLand(reelIndex: number, match?: { matchedValue: number; reelIndex: number }): void {
        super.onReelLand(reelIndex, match);

        Services.get(SoundService).customEvent("base_reel_land_" + reelIndex);

        const result = gameState.getCurrentGame().getLatestResultOfType(SlingoReelSpinResult);
        const landedSymbol = result.symbols[reelIndex];

        if (["J", "SJ", "FS", "P"].indexOf(landedSymbol) !== -1) {
            Components.get(MatrixComponent)
                .getSymbol(reelIndex, 0)
                .win()
                .execute();
        }

        if (landedSymbol === "FS") {
            Services.get(SoundService).customEvent(FowlSoundEvents.free_spin_spark);
        }
    }
}
